export class CreatePermissionViewModel {
    permissionID: number = 0;
    description:string;
    permissionName:string;
    moduleId: number
    createdOn:Date;
    createdBy: number;
    isActive: boolean;
    addPermission: boolean;
    editPermission: boolean;
    deletePermission: boolean;
    organizationID: number = 0;
    officeID:number=0;
}
